import { render, staticRenderFns } from "./EmployeeViolation.vue?vue&type=template&id=2a33e625"
import script from "./EmployeeViolation.vue?vue&type=script&lang=js"
export * from "./EmployeeViolation.vue?vue&type=script&lang=js"
import style0 from "./EmployeeViolation.vue?vue&type=style&index=0&id=2a33e625&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports